export const padLeadingZeros = (num, size) => {
  var s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
};
export const withThousandsSeparator = num => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
